<template>
  <div>
    <div class="o-layout">
      <div 
        v-for="(number, index) in returnTitle.length"
        :key="index"
        class="o-layout__item u-1of3"
        :class="{'u-mrgn-top--4': index >= 3}">
        <div class="u-fg--obsidian u-txt--small"><EllipsisText :lineNum=1 :message="returnTitle[index]" /></div>
        <div v-if="returnData[index]" class="u-txt--fair u-txt--bold">
          <RodValue :return-value="returnData[index]" />
        </div>
        <div v-else class="u-txt--fair">
          -
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RodValue from 'shared/components/RodValue';
import EllipsisText from 'shared/components/Ellipsis/EllipsisText';

export default {
  name: 'ReturnHistory',
  props: {
    returnTitle: {
      type: Array,
      default: () => [],
    },
    returnData: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    RodValue,
    EllipsisText,
  }
};
</script>
